


















import { Component, Vue } from 'vue-property-decorator'
import TedsLogo from './TedsLogo/TedsLogo.vue'

@Component({
  components: {
    TedsLogo,
  },
})
export default class TedsLauncherMobileFooter extends Vue {
  public currentYear: number = new Date().getFullYear()
}
